import React, { useState } from 'react'
import './settings.scss'
import SinglePage from '../../../components/common/page/SinglePage'
import { useSelector } from 'react-redux'
import { RiArrowDownSLine } from 'react-icons/ri'


const Settings = () => {

    const { user } = useSelector((state) => state.userAuth)
    const { internet } = useSelector((state) => state.network)
    const [visible, setVisible] = useState(false)


    return (
        <div className='settings-div'>
            <SinglePage titleArray={['Settings']}>
                {/* Network */}
                <div className="section-div">
                    <div className="section-title">
                        <h4>Network</h4>
                    </div>
                    <div className="section-content-div">
                        <div className="option-div">
                            <div className="left">
                                <p className='title'>Network status</p>
                            </div>
                            <div className="right">
                                {internet ? <span className='text-badge green-text'>Online</span>
                                    : <span className='text-badge offline-text'>Offline</span>}
                            </div>
                        </div>
                        <div className="option-div">
                            <div className="left">
                                <p className='title'>Sync data</p>
                            </div>
                            <div className="right">
                                <select name="" id="">
                                    <option value="">Auto</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Service */}
                <div className="section-div">
                    <div className="section-title">
                        <h4>Service</h4>
                    </div>
                    <div className="section-content-div">
                        <div className="option-div">
                            <div className="left">
                                <p className='title'>My Cities list</p>
                            </div>
                            <div className="right" onClick={() => setVisible(!visible)}>
                                <p>{user?.city_list?.length} Cities</p>
                                <RiArrowDownSLine />
                            </div>
                        </div>
                    </div>
                    {visible && <div className="section-content-div">
                        <div className="option-div">
                            <table>
                                <tbody>
                                    {user?.city_list?.map((city, index) => {
                                        return <tr key={city?._id}>
                                            <td>{index + 1}</td>
                                            <td>{city?.city_name}</td>
                                            <td>{city?.pr_get_data_date}</td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>}
                </div>
            </SinglePage>
        </div>
    )
}

export default Settings